import { isSubTreeKey } from '../../../client/components/NavigationMenu/utils';
import { membersToFlatExtractors } from '../../flattenTree/utils/extractors';

const doesNodeHaveMemberOfType =
  (node) =>
  ([, getNodeMembersOfType]) => {
    const members = getNodeMembersOfType(node);
    return members && members.length > 0;
  };

export const isNodeEmpty = (node) => {
  const doesNodeHaveMembers = Object.entries(membersToFlatExtractors).some(
    doesNodeHaveMemberOfType(node),
  );
  if (doesNodeHaveMembers) {
    return false;
  }
  const subTreeKeys = Object.keys(node).filter(isSubTreeKey);
  return subTreeKeys.length === 0;
};

export const deleteEmptyCategories = (docsTree) => {
  Object.keys(docsTree).forEach((categoryKey) => {
    const category = docsTree[categoryKey];
    if (isNodeEmpty(category)) {
      delete docsTree[categoryKey];
    }
  });
};
